import { inject, Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { map, Observable } from 'rxjs';
import { RecordersStore } from '../store/recorders.store';
import { AuthService } from '@auth0/auth0-angular';
import { RoutePath } from 'src/app/shared/enums/route-path.enum';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard {
  private readonly router = inject(Router);
  private readonly auth = inject(AuthService);

  readonly recordersStore = inject(RecordersStore);

  canActivate(
    _: ActivatedRouteSnapshot,
    routerState: RouterStateSnapshot,
  ): Observable<boolean> {
    return this.auth.isAuthenticated$.pipe(
      map(isAuthenticated => {
        if (
          routerState.url.startsWith(`/${RoutePath.Platform}`) &&
          !isAuthenticated
        ) {
          this.router.navigate([RoutePath.Landing]);
          return false;
        }

        if (
          routerState.url.startsWith(`/${RoutePath.Landing}`) &&
          isAuthenticated
        ) {
          this.router.navigate([RoutePath.Platform]);
          return false;
        }

        // Only the user-facing /platform/trash is gated on owning a recorder.
        // Matched as a path, not a substring: the administration has a trash
        // section of its own (/platform/admin/trash) that this must not bounce.
        const path = routerState.url.split(/[?#]/)[0];
        if (
          path === `/${RoutePath.Platform}/${RoutePath.Trash}` &&
          !this.recordersStore.hasAnyRecorder()
        ) {
          this.router.navigate([RoutePath.Platform]);
          return false;
        }

        return true;
      }),
    );
  }
}
